<script setup lang="ts">
const props = defineProps<{
  isSelected: boolean
  cursor?: 'text' | 'pointer'
  label: string
  blockBackgroundColor?: string
  roundedEdge?: 'top' | 'bottom'
}>()

const emit = defineEmits<{
  (e: 'select'): void
}>()

// Mirror the rendered email: the background fills the whole block including its
// horizontal padding (px-10 here represents the email td padding).
const backgroundStyle = computed(() =>
  props.blockBackgroundColor ? { backgroundColor: `#${props.blockBackgroundColor}` } : undefined
)
</script>

<template>
  <div
    class="email-block group/block relative border px-10 py-1.5 transition-all duration-150"
    :class="[
      isSelected ? 'border-border bg-muted' : 'border-transparent hover:border-border hover:bg-muted/50',
      cursor === 'text' ? 'cursor-text' : 'cursor-pointer',
      roundedEdge === 'top' ? 'rounded-t-xl' : roundedEdge === 'bottom' ? 'rounded-b-xl' : ''
    ]"
    :style="backgroundStyle"
    @click="emit('select')"
  >
    <span
      v-if="isSelected"
      class="absolute -top-3 left-2 bg-white px-2 py-1 text-xs border border-border shadow-sm text-foreground-secondary rounded-full z-10"
    >
      {{ label }}
    </span>
    <slot />
  </div>
</template>
